import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import { type SxProps } from '@mui/material/styles'

type Color = 'primary' | 'inherit' | 'secondary' | 'success' | 'error' | 'info' | 'warning'

type FooterProps = {
  footerStyles?: SxProps
  hasSecondaryAction?: boolean
  isPrimaryDisabled?: boolean
  onPrimaryAction?: () => void
  onSecondaryAction?: () => void
  primaryButtonProps?: React.ComponentProps<typeof Button>
  primaryColor?: Color
  primaryText?: string
  secondaryColor?: Color
  secondaryText?: string
}

const Footer = ({
  footerStyles = {},
  hasSecondaryAction = true,
  isPrimaryDisabled,
  onPrimaryAction,
  onSecondaryAction,
  primaryButtonProps = {},
  primaryColor = 'primary',
  primaryText = 'Save',
  secondaryColor = 'primary',
  secondaryText = 'Cancel',
}: FooterProps) => {
  return (
    <Stack
      sx={{
        bgcolor: 'background.paper',
        flexDirection: 'row',
        gap: 16,
        justifyContent: 'flex-end',
        p: 24,
        ...footerStyles,
      }}
    >
      {hasSecondaryAction && (
        <Button
          color={secondaryColor}
          onClick={onSecondaryAction}
          variant={onPrimaryAction ? 'outlined' : 'contained'}
        >
          {secondaryText}
        </Button>
      )}

      {onPrimaryAction && (
        <Button
          {...primaryButtonProps}
          color={primaryColor}
          disabled={isPrimaryDisabled}
          onClick={onPrimaryAction}
          variant="contained"
        >
          {primaryText}
        </Button>
      )}
    </Stack>
  )
}

export default Footer
